<!-- 首页点击跳转调查问卷页面 -->
<template>
  <div class="questionnaire">
    <div class="questionnaireDetail">
      <div class="questionnaireName">
        {{ this.QuestionnaireInDetail.name }}
      </div>
      <div class="introduction">
        {{ this.QuestionnaireInDetail.introduction }}
      </div>
      <div class="stratTime">
        问卷开始时间：{{ this.QuestionnaireInDetail.startTime }}
      </div>
      <div class="endTime">
        问卷结束时间：{{ this.QuestionnaireInDetail.endTime }}
      </div>
      <hr />
      <el-form :model="subject" ref="subject">
        <div
          class="subjectDiv"

          v-for="item in questionnaire.QuestionInfo"
          :key="item.num"
        >
          <div class="subject" v-if="item.type == 1 && item.flag == 1">
            <div class="titleAndIcon clearfix">
              <div class="title">第{{ item.num }}题：{{ item.name }}</div>
              <div class="icon">[单选] [必填]</div>
            </div>
            <div class="radio">
              <el-form-item
                :prop="item.option.value"
                :rules="{ required: true, message: '请选择', trigger: 'blur' }"
              >
                <el-radio-group v-model="item.value">
                  <el-radio
                    v-for="index in item.option"
                    :key="index.id"
                    :label="index.value"
                  ></el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </div>
          <div class="subject" v-else-if="item.type == 1 && item.flag == 0">
            <div class="titleAndIcon clearfix">
              <div class="title">第{{ item.num }}题：{{ item.name }}</div>
              <div class="icon">[单选]</div>
            </div>
            <div class="radio">
              <el-form-item>
                <el-radio-group v-model="item.value">
                  <el-radio
                    v-for="index in item.option"
                    :key="index.id"
                    :label="index.value"
                  ></el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </div>
          <div class="subject" v-else-if="item.type == 2 && item.flag == 1">
            <div class="titleAndIcon clearfix">
              <div class="title">第{{ item.num }}题：{{ item.name }}</div>
              <div class="icon">[多选] [必填]</div>
            </div>
            <div class="checkbox">
              <el-form-item
                :prop="item.option.value"
                :rules="{
                  required: true,
                  message: '请选择',
                  trigger: 'blur',
                }"
              >
                <el-checkbox-group v-model="item.value">
                  <el-checkbox
                    v-for="index in item.option"
                    :key="index.id"
                    :label="index.value"
                  >
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </div>
          </div>
          <div class="subject" v-else-if="item.type == 2 && item.flag == 0">
            <div class="titleAndIcon clearfix">
              <div class="title">第{{ item.num }}题：{{ item.name }}</div>
              <div class="icon">[多选]</div>
            </div>
            <div class="checkbox">
              <el-form-item>
                <el-checkbox-group v-model="item.value">
                  <el-checkbox
                    v-for="index in item.option"
                    :key="index.id"
                    :label="index.value"
                  >
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <div class="submitDiv">
      <button class="submit" @click="submit">提 交</button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      questionnaire: "",
      QuestionnaireInDetail: "",
      subject: { problem_info: [] },
      postData: {
        page: 1,
        pageSize: 8,
        type: 2,
      },
    };
  },
  created() {
    this.getQuestionnaireDetai();
  },
  methods: {
    async getQuestionnaireDetai() {
      const result = await this.$http.get(
        "/questionnaire/getQuestionnaireInDetail",
        {
          params: { id: this.$route.query.id },
        }
      );
      this.questionnaire = result.data;
      this.QuestionnaireInDetail = result.data.QuestionnaireInDetail;
      this.subject.problem_info = result.data.QuestionInfo;
    },
    submit() {
      console.log("问卷内容", this.subject.problem_info);
      this.$refs.subject.validate(async (valid) => {
        // // 请求api之前的一个前端验证
        // if (!valid) {
        //   return;
        // }

        for (var i = 0; i < this.subject.problem_info.length; i++) {
          if (
            this.subject.problem_info[i].value == null ||
            this.subject.problem_info[i].value.length == 0
          ) {
            this.$toast("以上选项全部不允许为空");
            return;
          }
        }
        const result = await this.$http.post(
          "/questionnaire/pushQuestionnaire",
          {
            surveyId: parseInt(this.$route.query.id),
            userId: window.localStorage.getItem("user_id"),
            content: this.subject.problem_info,
          }
        );
        // const result = await this.$http({
        //   url: "/questionnaire/pushQuestionnaire",
        //   method: "POST",
        //   headers: { 'Content-Type': 'application/json' },
        //   data: {
        //     surveyId: parseInt(this.$route.query.id),
        //     userId: parseInt(window.localStorage.getItem("user_id")),
        //     content: this.subject.problem_info,
        //   },
        // });

        if (result.data.success == true) {
          this.$toast("提交成功");
          window.history.back(-1);
        } else {
          this.$toast(result.data.msg);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.clearfix {
  *zoom: 1;
}

.questionnaire {
  position: relative;
  .questionnaireDetail {
    position: relative;
    left: 5%;
    width: 90%;
    margin-top: 10px;
    background-color: rgb(255, 255, 255);
    border-radius: 15px;
    .questionnaireName {
      padding: 20px 0;
      font-size: 1.1rem;
      font-weight: bold;
      color: #333333;
      text-align: center;
    }

    .introduction {
      position: relative;
      left: 2%;
      width: 96%;
      font-size: 1rem;
      font-weight: bold;
      color: #666666;
      text-indent: 2rem;
      line-height: 1.5rem;
      margin-bottom: 20px;
    }

    .stratTime,
    .endTime {
      font-weight: 400;
      font-size: 0.9rem;
      color: #999999;
      text-align: center;
      margin-bottom: 5px;
    }

    hr {
      margin-block-start: 1em;
      margin-block-end: 1em;
      background-color: #f5f5f5;
    }

    .el-form {
      position: relative;
      left: 5%;
      width: 90%;

      .titleAndIcon {
        .title {
          float: left;
          font-weight: bold;
          color: #333333;
          font-size: 0.85rem;
        }

        .icon {
          float: left;
          margin-left: 6px;
          font-weight: 400;
          color: #999999;
          font-size: 0.85rem;
        }
      }

      .el-form-item {
        margin-top: 10px;
        background: #f5f5f5;
        border: 1px solid #cccccc;
        border-radius: 20px;

        .el-checkbox {
          display: block;
          margin: 10px 20px 10px 20px;
          background: #f5f5f5;

          /deep/.el-checkbox__label {
            text-overflow: ellipsis;
            white-space: normal;
            line-height: 18px;
            vertical-align: middle;
            display: inline-block;
            word-wrap: break-word;
            word-break: break-all;
          }
        }

        .el-radio-group {
          width: 100%;

          .el-radio {
            display: block;
            margin: 10px 20px 10px 20px;
            padding: 5px 0;
            background: #f5f5f5;

            /deep/.el-radio__label {
              text-overflow: ellipsis;
              white-space: normal;
              line-height: 18px;
              vertical-align: middle;
              display: inline-block;
              word-wrap: break-word;
              word-break: break-all;
            }
          }
        }
      }
    }
  }

  .submitDiv {
    position: relative;
    left: 5%;
    width: 90%;

    .submit {
      margin-bottom: 10px;
      width: 100%;
      font-size: 1.1rem;
      background: linear-gradient(270deg, #00706E, #00706E);
      border-radius: 45px;
      border: none;
      padding: 10px 0;
      color: white;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/questionnaire/QuestionnaireDetail.vue